import script from "./PaginationBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginationBase.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__